import { render, staticRenderFns } from "./MdmUploadApp.vue?vue&type=template&id=9faa43fa&scoped=true&"
import script from "./MdmUploadApp.vue?vue&type=script&lang=js&"
export * from "./MdmUploadApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9faa43fa",
  null
  
)

export default component.exports